export var getDefaultStyleSheet = _ref => {
  var {
    isHorizontal
  } = _ref;
  return {
    wrapperStyle: {
      flexDirection: isHorizontal ? 'row' : 'column'
    }
  };
};
//# sourceMappingURL=getDefaultStyleSheet.js.map